module.exports = __webpack_public_path__ + "img/limit.0e32325.svg";